import {
  RESET_CLUB_PACKAGE_ISFETCHING,
  CLUB_PACKAGE_OBJECT_REQUESTING,
  GET_CLUB_PACKAGE_SUCCESS,
  LIST_CLUB_PACKAGES_SUCCESS
} from './constants';

const INITIAL_STATE = {
  data: null,
  isListFetching: false,
  isObjectFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CLUB_PACKAGE_ISFETCHING: {
      return {
        ...state,
        isListFetching: false,
        isObjectFetching: false
      };
    }
    case CLUB_PACKAGE_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case GET_CLUB_PACKAGE_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        data,
        isObjectFetching: false
      };
    }
    case LIST_CLUB_PACKAGES_SUCCESS: {
      const data = { ...state.data };
      action.payload.clubPackages.forEach((clubPackage) => {
        data[clubPackage.id] = clubPackage;
      });
      return {
        data,
        isListFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getClubPackageByClubId = (clubPackages, clubId) => {
  if (!clubPackages.data) {
    return null;
  }
  const clubPackageIds = Object.keys(clubPackages.data);
  const clubPackageByClubId = clubPackageIds.find(
    (id) => clubPackages.data[id].clubId === clubId
  );
  if (clubPackageByClubId) {
    return clubPackages.data[clubPackageByClubId];
  }
  return null;
};
